import { formatarMesAno } from '@/pages/agenda/utils';

interface SeletorMesProps {
  data: Date;
  onAnterior: () => void;
  onProximo: () => void;
}

export default function SeletorMes({ data, onAnterior, onProximo }: SeletorMesProps) {
  return (
    <div className="flex items-center justify-center gap-2">
      <button
        type="button"
        onClick={onAnterior}
        aria-label="Mês anterior"
        className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-900"
      >
        <i className="ri-arrow-left-s-line text-xl" />
      </button>

      <span className="min-w-[150px] text-center text-base font-bold capitalize text-foreground-950">
        {formatarMesAno(data)}
      </span>

      <button
        type="button"
        onClick={onProximo}
        aria-label="Próximo mês"
        className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-foreground-600 transition-colors hover:bg-background-100 hover:text-foreground-900"
      >
        <i className="ri-arrow-right-s-line text-xl" />
      </button>
    </div>
  );
}